<template>
  <header
    class="fixed flex bg-white border-b border-gray/10 justify-center w-full top-0 left-0 py-4 z-50"
  >
    <div
      class="container-lg rounded-[32px] w-full flex-y-center justify-between rtl:flex-row-reverse"
    >
      <LocalizedLink to="/home" class="px-2 !bg-transparent">
        <img src="/landing/logo/saraf-logo-dark.svg" alt="Saraf Logo" />
      </LocalizedLink>

      <nav class="hidden md:flex">
        <ul class="flex-y-center gap-4">
          <li v-for="(link, index) of links" :key="index">
            <LocalizedLink
              :to="link.url"
              class="text-dark rounded-2xl text-base transition-300 hover:text-green"
            >
              {{ $t(link.title) }}
            </LocalizedLink>
          </li>
        </ul>
      </nav>
      <div class="flex items-center gap-4 rtl:flex-row-reverse">
        <CLanguageSwitcher
          class="border border-[#f0f0f0] rounded-lg py-1 px-2"
        />
        <div class="items-center gap-2 md:flex hidden" v-if="user?.id">
          <CProfileDropdown :user="user" />
        </div>
        <div class="items-center gap-2 md:flex hidden" v-else>
          <LocalizedLink to="/auth/login">
            <Button
              :text="$t('landing.links.sign_in')"
              size="sm"
              variant="outline"
              class="flex-y-center px-[12px] flex-y-center !justify-center"
            />
          </LocalizedLink>
          <LocalizedLink to="/auth/register">
            <Button
              :text="$t('landing.links.sign_up')"
              size="sm"
              class="flex-y-center px-[12px] flex-y-center !justify-center"
            />
          </LocalizedLink>
        </div>
        <div class="flex items-center gap-2 block md:hidden" v-if="user?.id">
          <CProfileDropdown :user="user" mobile />
          <button @click="showBurgerMenu">
            <i class="icon-menu text-dark mx-2 lg:hidden block text-[28px]"></i>
          </button>
        </div>
        <div class="flex items-center gap-2" v-else>
          <RouterLink to="/auth/register" class="md:hidden">
            <Button
              variant="primary"
              size="sm"
              class="px-10"
              text="Start Now"
            />
          </RouterLink>
          <button @click="showBurgerMenu" class="block md:hidden">
            <i class="icon-menu text-dark mx-2 lg:hidden block text-[28px]"></i>
          </button>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import CLanguageSwitcher from "@/components/CLanguageSwitcher.vue";
import CProfileDropdown from "@/layout/Dashboard/components/CProfileDropdown.vue";
import Button from "@/modules/Landing/components/Base/Button/Button.vue";
import { links } from "@/data";
import { useAuthStore } from "@/modules/Auth/stores";
import { computed } from "vue";

interface Emits {
  (e: "showMobileMenu"): void;
}
const emit = defineEmits<Emits>();

const store = useAuthStore();

const user = computed(() => store?.user);

const showBurgerMenu = () => {
  emit("showMobileMenu");
};
</script>
